import { render, staticRenderFns } from "./pop_order_list.vue?vue&type=template&id=2de1c15e"
import script from "./pop_order_list.vue?vue&type=script&lang=js"
export * from "./pop_order_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports